export const getYandexClientID = () => {
  if (window?.ym_35856070?.getClientID) {
    return window.ym_35856070.getClientID();
  }

  return;
};
